export default "__VITE_ASSET__sSruRLzQ__"